import React, { useState, useRef } from 'react';
import { Fade } from 'react-awesome-reveal';
import axios from 'axios'; //  Ensure Axios is correctly imported
import dealership from '../../Assets/fleet/section 1/last1.png';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import '../../Atoms/Button/style.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCaptchaV2 from 'react-google-recaptcha';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export default function Fleetsolutions() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    phone: '',
    notes: '',
  });
  // Error State
  const [errors, setErrors] = useState({});
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const [loading, setLoading] = useState(false);
  // reCAPTCHA Site Key
  const RECAPTCHA_SITE_KEY = '6LdwRAArAAAAAOc9Sxvr3IPNP6YbMaToGGQLnZAz';

  // Open modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({
      name: '',
      email: '',
      organization: '',
      phone: '',
      notes: '',
    });
    setErrors({});
    setCaptchaToken(null);
    // captchaRef.current?.reset();
  };

  // Handle reCAPTCHA
  const handleCaptchaChange = (token) => setCaptchaToken(token);
  const handleCaptchaExpire = () => {
    setCaptchaToken(null);
    setTimeout(() => {
      if (captchaRef.current) {
        captchaRef.current.reset();
      }
    }, 500);
    toast.warning('reCAPTCHA expired! Please verify again.');
  };

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    let newErrors = {};

    // Email Validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!emailPattern.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address.';
    }

    // Validation
    if (!formData.name.trim()) newErrors.name = 'Name is required.';
    if (!formData.organization.trim())
      newErrors.organization = 'Organization is required.';
    if (!formData.phone.trim() || !/^\d{6,15}$/.test(formData.phone))
      newErrors.phone = 'Phone number should be more than 8 digits.';
    if (!formData.notes.trim()) newErrors.notes = 'Notes are required.';
    if (!formData.email.trim()) newErrors.email = 'Email is required.';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Extract username from email
    const username = formData.email.split('@')[0];
    const heading = 'Connect with an expert';
    // Construct the full request data
    const requestData = {
      name: formData.name,
      email: formData.email,
      username: username,
      heading: heading,
      organization: formData.organization,
      phone: formData.phone,
      notes: formData.notes,
    };

    try {
      //  Send email + username to backend

      const endpoint = 'https://mailservice.verdemobility.com/api/Email/request-demo';
      //  Send request to backend
      await axios.post(endpoint, requestData, {
        headers: {
          Authorization: `Bearer ${captchaToken}`, // Send reCAPTCHA token in the header
        },
      });

      //  Show success toast
      toast.success('Connect to Expert request submitted successfully!', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: 'colored',
      });

      closeModal();
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to submit request. Try again later.');
    } finally {
      setLoading(false); // Hide loader
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <section className="bg-light-gradient blade-margin">
        <section className="max-w-screen-xl w-11/12 md:w-10/12 mx-auto grid grid-cols-1 grid-rows-2 md:grid-cols-9 md:grid-rows-1">
          <div className="row-start-2 lg:row-start-1 row-end-3 lg:row-end-2 col-start-1 col-end-10 lg:col-end-5 py-5 md:py-10 flex flex-col items-start justify-center gap-3">
            <h3 className="font-gilroylight">
              <strong>Fleet charging simplified</strong>
            </h3>
            <p className="font-poppins font-light pt-2 md:pt-6">
              Manage your EVs with our comprehensive charging solutions specifically engineered for fleets
            </p>
            <div className="flex flex-wrap md:flex-nowrap gap-6 md:gap-10 items-start md:items-center pt-5 md:pt-8 lg:pt-14">
              {/*  Kept "Connect with an Expert" button design UNCHANGED */}
              <div
                className='mt-5'
                onClick={openModal}
              >
                <button
                  className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                >
                  <span className="flex justify-center items-center">
                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                  </span>
                  Connect with an Expert
                </button>
              </div>
              {/* <button
                onClick={openModal}
                className="btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6"
              >
                <span className="flex justify-center items-center">
                  <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                  <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                </span>
                Connect with an Expert
              </button> */}
            </div>
          </div>

          {/* Right Section - Image */}
          <div className="row-start-1 row-end-2 lg:row-start-1 col-start-1 lg:col-start-6 col-end-10 bg-green xl:h-[40rem] lg:h-[34rem] h-[24rem]">
            <img
              loading="lazy"
              src={dealership}
              className="object-cover object-center h-full w-full"
              alt="dealership"
            />
          </div>
        </section>
      </section>

      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-4"
          onClick={closeModal}
        >
          <div
            className="bg-white p-6 md:p-8 rounded-lg shadow-lg w-full max-w-lg md:max-w-2xl lg:max-w-3xl max-h-screen overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl md:text-2xl font-semibold mb-6 font-gilroylight text-center">
              Connect with an Expert
            </h2>

            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 md:grid-cols-2 gap-4"
            >
              <>
                {/* Name */}
                <div>
                  {/* <label className="block text-gray-700 text-lg mb-1">
                      Name <span className="text-red-500">*</span>
                    </label> */}
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, name: '' }));
                    }}
                    onBlur={() => {
                      if (!formData.name.trim())
                        setErrors((prev) => ({
                          ...prev,
                          name: 'Name is required.',
                        }));
                    }}
                    placeholder="Name *"
                    className={`w-full p-3 border rounded-lg text-lg ${errors.name ? 'border-red-500' : 'border-gray-300'
                      }`}
                  />
                  {errors.name && (
                    <p className="text-red-500 text-lg mt-1">{errors.name}</p>
                  )}
                </div>

                {/* Organization */}
                <div>
                  {/* <label className="block text-gray-700 text-lg mb-1">
                      Organization Name <span className="text-red-500">*</span>
                    </label> */}
                  <input
                    type="text"
                    name="organization"
                    value={formData.organization}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, organization: '' }));
                    }}
                    onBlur={() => {
                      if (!formData.organization.trim())
                        setErrors((prev) => ({
                          ...prev,
                          organization: 'Organization is required.',
                        }));
                    }}
                    placeholder="Organization *"
                    className={`w-full p-3 border rounded-lg text-lg ${errors.organization ? 'border-red-500' : 'border-gray-300'
                      }`}
                  />
                  {errors.organization && (
                    <p className="text-red-500 text-lg mt-1">
                      {errors.organization}
                    </p>
                  )}
                </div>
                {/* Email */}
                <div>
                  {/* <label className="block text-gray-700 text-lg mb-1">
                      Email <span className="text-red-500">*</span>
                    </label> */}
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, email: '' }));
                    }}
                    onBlur={() => {
                      if (!formData.email.trim())
                        setErrors((prev) => ({
                          ...prev,
                          email: 'Email is required.',
                        }));
                    }}
                    placeholder="Email *"
                    className={`w-full p-3 border rounded-lg text-lg ${errors.email ? 'border-red-500' : 'border-gray-300'
                      }`}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-lg mt-1">{errors.email}</p>
                  )}
                </div>

                {/* Phone */}
                <div>
                  {/* <label className="block text-gray-700 text-lg mb-1">
                      Phone <span className="text-red-500">*</span>
                    </label> */}
                  <PhoneInput
                    country={'us'}
                    value={formData.phone}
                    onChange={(value) => {
                      // value from react-phone-input-2 is usually like '14155552671' (no +)
                      // So prepend + before validating
                      const phoneWithPlus = '+' + value;

                      setFormData((prev) => ({ ...prev, phone: phoneWithPlus }));

                      if (/^\d{6,15}$/.test(phoneWithPlus)) {
                        setErrors((prev) => ({ ...prev, phone: '' }));
                      } else {
                        setErrors((prev) => ({
                          ...prev,
                          phone: 'Please enter a valid international phone number starting with + and 6 to 15 digits.',
                        }));
                      }
                    }}
                    onBlur={() => {
                      if (!formData.phone.trim()) {
                        setErrors((prev) => ({
                          ...prev,
                          phone: 'Phone number is required.',
                        }));
                      } else if (!/^\d{6,15}$/.test(formData.phone)) {
                        setErrors((prev) => ({
                          ...prev,
                          phone: 'Please enter a valid international phone number starting with + and 6 to 15 digits.',
                        }));
                      }
                    }}
                    inputProps={{
                      name: 'phone',
                      required: true,
                      placeholder: 'Phone number (international format, e.g. +123456789)',
                    }}
                    containerClass="w-full"
                    inputClass={`!w-full !p-3 !pl-11 !text-lg !rounded-lg !h-[52px] ${errors.phone ? '!border-red-500' : '!border-gray-300'}`}
                  />

                  {errors.phone && (
                    <p className="text-red-500 text-lg mt-1">{errors.phone}</p>
                  )}
                </div>

                {/* Notes */}
                <div className="md:col-span-2">
                  {/* <label className="block text-gray-700 text-lg mb-1">
                      Notes <span className="text-red-500">*</span>
                    </label> */}
                  <textarea
                    name="notes"
                    value={formData.notes}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, notes: '' }));
                    }}
                    onBlur={() => {
                      if (!formData.notes.trim())
                        setErrors((prev) => ({
                          ...prev,
                          notes: 'Notes are required.',
                        }));
                    }}
                    placeholder="Notes/Additional details *"
                    className={`w-full p-3 border rounded-lg text-lg ${errors.notes ? 'border-red-500' : 'border-gray-300'
                      }`}
                    rows="3"
                  ></textarea>
                  {errors.notes && (
                    <p className="text-red-500 text-lg mt-1">{errors.notes}</p>
                  )}

                  {/* reCAPTCHA */}
                  <div>
                    <ReCaptchaV2
                      sitekey={RECAPTCHA_SITE_KEY}
                      ref={captchaRef}
                      onChange={handleCaptchaChange}
                      onExpired={handleCaptchaExpire}
                    />
                  </div>
                </div>
              </>

              <div className="col-span-1 md:col-span-2 flex justify-end mt-6">
                <button
                  type="button"
                  onClick={closeModal}
                  className="mr-3 px-5 py-3 bg-gray-300 rounded-lg text-lg"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-3 bg-[#03d077] text-white rounded-lg text-lg"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
